import type { SelectChangeEvent } from '@mui/material';
import type { TableRowType } from '../../../../grid/reduxStore/table.types';
import { TotalRowTypesIdentifier } from '../../../../grid/reduxStore/table.types';
import { getDefaultHTMLForSubtotalRowTitle } from '../../../../GridDndEditor/Block/Table/defaultData';
import { useTableContentUndoRedo } from '../../../../hooks/useTableContentUndoRedo';
import type { RootState } from '../../../../grid/reduxStore/Store';
import { useAppSelector } from '../../../../grid/reduxStore/Store';
import { selectContentTable } from '../../../../grid/reduxStore/editorSlice';
import { SelectionContext } from '../../../../GridDndEditor/SelectedBlockInfoProvider';
import { useContext } from 'react';

const useTableFooterRowTypeChange = () => {
  const { selectedBlockIdByWrapper, selectedSectionId } = useContext(SelectionContext);
  const blockId = selectedBlockIdByWrapper as string;
  const sectionId = selectedSectionId as string;

  const tableData = useAppSelector((state: RootState) => selectContentTable(state, sectionId, blockId)) || [];
  const { selectedRow, totalRows } = tableData;

  const { handleTableContentChanged } = useTableContentUndoRedo();

  const updateRowTitleBasedOnType = (row: TableRowType, rowType: TotalRowTypesIdentifier): TableRowType => {
    const shouldUpdateRowTitle = [TotalRowTypesIdentifier.TAX, TotalRowTypesIdentifier.DISCOUNT].includes(rowType);
    if (shouldUpdateRowTitle) {
      return { ...row, title: getDefaultHTMLForSubtotalRowTitle(rowType) };
    }

    return row;
  };

  const handleRowTypeChange = async (e: SelectChangeEvent) => {
    const rowType = e.target.value as TotalRowTypesIdentifier;

    if (blockId && selectedRow && totalRows && rowType !== selectedRow.rowType) {
      let updatedSelectedRow = selectedRow;
      const updatedRows = totalRows?.map((row) => {
        if (row.id === selectedRow.id) {
          updatedSelectedRow = { ...row, price: '', rowType: rowType };
          updatedSelectedRow = updateRowTitleBasedOnType(updatedSelectedRow, rowType);
          return updatedSelectedRow;
        }
        return row;
      });
      const updatedTableData = {
        ...tableData,
        totalRows: updatedRows,
        metadata: {
          ...tableData.metadata,
        },
        selectedRow: updatedSelectedRow,
      };
      handleTableContentChanged(blockId, sectionId, tableData, updatedTableData);
    }
  };

  return { handleRowTypeChange };
};

export default useTableFooterRowTypeChange;
